import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const ScrollToHomeButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    user_name: "",
    user_phone: "",
    user_courses: [],
  });

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCourseChange = (e) => {
    const value = e.target.value;
    const updatedCourses = formData.user_courses.includes(value)
      ? formData.user_courses.filter((course) => course !== value)
      : [...formData.user_courses, value];

    setFormData({ ...formData, user_courses: updatedCourses });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { user_name, user_phone, user_courses } = formData;

    if (!user_name || !user_phone) {
      toast.error("Please fill in all the required fields.");
      return;
    }

    if (!/^\d{10}$/.test(user_phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    if (user_courses.length === 0) {
      toast.error("Please select at least one course.");
      return;
    }

    const templateParams = {
      user_name,
      user_phone,
      user_courses: user_courses.join(", "),
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          toast.success(
            " Thank you for registering!  our team will contact you soon."
          );
          setIsModalOpen(false);
          setFormData({
            user_name: "",
            user_phone: "",
            user_courses: [],
          });
        },
        (error) => {
          toast.error("Failed to send email. Please try again.");
          console.error("Email error:", error);
        }
      );
  };

  return (
    <div className="w-full flex justify-center bg-[#090522] pb-6 md:pb-10">
      <button
        onClick={openModal}
        className="text-white text-lg font-semibold px-8 py-4 rounded-full bg-gradient-to-r from-orange-500 to-yellow-400 hover:scale-105 transition-transform duration-300"
        aria-label="Open registration modal"
      >
        FREE DEMO CLASS
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="w-[85%] md:w-2/4 bg-black/70 p-6 rounded-lg mt-10 md:mt-0 relative">
            <button
              onClick={closeModal}
              className="absolute top-3 right-3 text-white text-2xl"
            >
              &times;
            </button>

            <h2 className="text-yellow-400 text-xl font-bold mb-4">
              Hey buddy! Fill the form for FREE counselling on VFX & 3D
              Animation courses!
            </h2>
            <form className="flex flex-col space-y-4">
              <input
                type="text"
                name="user_name"
                placeholder="NAME"
                value={formData.user_name}
                onChange={handleChange}
                className="p-3 rounded bg-transparent border border-yellow-400 text-white placeholder-yellow-400 focus:outline-none"
              />
              <input
                type="text"
                name="user_phone"
                placeholder="PHONE NUMBER"
                value={formData.user_phone}
                onChange={handleChange}
                className="p-3 rounded bg-transparent border border-yellow-400 text-white placeholder-yellow-400 focus:outline-none"
              />
              <div className="text-white space-y-2">
                {[
                  "3D Animation",
                  "VFX",
                  "Game Development",
                  "Video Editing",
                  "Motion Graphics",
                  "Graphics Design",
                  "UI/UX Design",
                ].map((option, index) => {
                  return (
                    <label
                      key={index}
                      className="flex items-center space-x-2 text-white"
                    >
                      <input
                        type="checkbox"
                        value={option}
                        checked={formData.user_courses.includes(option)}
                        onChange={handleCourseChange}
                      />
                      <span>{option}</span>
                    </label>
                  );
                })}
              </div>
              <button
                type="submit"
                onClick={handleSubmit}
                className="p-3 rounded bg-gradient-to-r from-yellow-400 to-yellow-200 font-bold text-black hover:from-yellow-300 hover:to-yellow-500"
              >
                REGISTER
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScrollToHomeButton;
